export const SET_FIELD = 'DPT_OUTSIDE_SERVICES/SET_FIELD';
export const FETCH_DATA = 'DPT_OUTSIDE_SERVICES/FETCH_DATA';
export const FETCH_DATA_SUCCESS = 'DPT_OUTSIDE_SERVICES/FETCH_DATA_SUCCESS';
export const FETCH_DATA_ERROR = 'DPT_OUTSIDE_SERVICES/FETCH_DATA_ERROR';
export const SAVE = 'DPT_OUTSIDE_SERVICES/SAVE';
export const SAVE_SUCCESS = 'DPT_OUTSIDE_SERVICES/SAVE_SUCCESS';
export const SAVE_ERROR = 'DPT_OUTSIDE_SERVICES/SAVE_ERROR';
export const FETCH_ELEMENT = 'DPT_OUTSIDE_SERVICES/FETCH_ELEMENT';
export const FETCH_ELEMENT_SUCCESS = 'DPT_OUTSIDE_SERVICES/FETCH_ELEMENT_SUCCESS';
export const FETCH_ELEMENT_ERROR = 'DPT_OUTSIDE_SERVICES/FETCH_ELEMENT_ERROR';
export const SET_ACTIVE_PAGE = 'DPT_OUTSIDE_SERVICES/SET_ACTIVE_PAGE';
export const RESET_FORM = 'DPT_OUTSIDE_SERVICES/RESET_FORM';